import { render } from "./CheckboxSliderComponent.vue?vue&type=template&id=58796a9c"
import script from "./CheckboxSliderComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxSliderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__